import Vue from 'vue'

import { formatToBRL } from 'brazilian-values'
import { formatDate } from '../util/formatters'
import moment from 'moment'

Vue.filter('currency', value => {
  if (!value) {
    return 'R$ 0,00'
  }

  return formatToBRL(value)
})

Vue.filter('decimal', value => {
  if (!value) {
    return '0,00'
  }

  return formatToBRL(value).replace('R$', '')
})

Vue.filter('integer', value => {
  if (!value) {
    return '0'
  }

  return Math.round(Number(value)).toLocaleString('pt-BR')
})

Vue.filter('percent', value => {
  if (!value) {
    return '0,00 %'
  }

  return `${formatToBRL(value).replace('R$', '')} %`
})

Vue.filter('date', value => {
  if (!value) {
    return ''
  }

  if (value.includes('/')) {
    return value
  }

  return formatDate(new Date(value).toISOString().substr(0, 10))
})

Vue.filter('month', value => {
  if (!value) {
    return ''
  }

  return moment(value).format('MM/YYYY')
})

Vue.filter('dateTime', value => {
  if (!value) {
    return ''
  }

  return moment(value).format('DD/MM/YYYY HH:mm')
})

Vue.filter('time', value => {
  if (!value) {
    return ''
  }

  return moment(value).format('HH:mm')
})
